module.exports = __webpack_public_path__ + "static/media/logo-enjoy.f2209aeb.svg";